"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlphaInputField = void 0;
const react_1 = __importStar(require("react"));
const ColorPicker_module_css_1 = __importDefault(require("../public/ColorPicker.module.css"));
const AlphaInputField = (props) => {
    const { color } = props;
    const [isAlphaInputFocused, setAlphaInputFocused] = (0, react_1.useState)(false);
    const [alphaInputValue, setAlphaInputValue] = (0, react_1.useState)("100");
    const alphaChange = (event) => {
        let value = event.target.value;
        if (value.length > 3) {
            value = value.substring(0, 3);
        }
        setAlphaInputValue(value);
        if (!/^\d{1,3}$/.test(value)) {
            return;
        }
        let numberValue = parseInt(value);
        numberValue = numberValue > 100 ? 100 : numberValue;
        const alphaValue = numberValue / 100;
        color.setAlpha(alphaValue);
        color.updateAlphaSelector();
    };
    const focusHandler = (event) => {
        setAlphaInputFocused(true);
        setAlphaInputValue(color.getOpacityWithoutPercent());
        setTimeout(() => event.target.select(), 0);
    };
    const blurHandler = () => {
        setAlphaInputFocused(false);
        setAlphaInputValue(color.getOpacityWithoutPercent());
    };
    const clickHandler = () => {
        var _a;
        if (color.alphaInputRef) {
            (_a = color.alphaInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    return (react_1.default.createElement("div", { className: `${ColorPicker_module_css_1.default.alpha_input_field_wrapper} ${ColorPicker_module_css_1.default.color_input_fields}`, onClick: clickHandler },
        react_1.default.createElement("input", { ref: color.alphaInputRef, value: isAlphaInputFocused ? alphaInputValue : color.getOpacityWithoutPercent(), onBlur: blurHandler, onCopy: (e) => e.preventDefault(), onFocus: focusHandler, onChange: alphaChange, className: ColorPicker_module_css_1.default.alpha_input_field, "data-cy": "ColorPickerAlphaInput" }),
        react_1.default.createElement("span", { className: ColorPicker_module_css_1.default.percent_span, onClick: clickHandler }, "%")));
};
exports.AlphaInputField = AlphaInputField;
